
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rapid-series-power-bank",
      function () {
        return require("private-next-pages/rapid-series-power-bank/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rapid-series-power-bank"])
      });
    }
  